console.log('custom-collection-filters.js loaded');

function keepFiltersOpen() {
  // Open all details
  document.querySelectorAll('.mobile-facets__details').forEach((el) => {
    el.setAttribute('open', 'true');
  });

  // Reset styles on submenus
  document.querySelectorAll('.mobile-facets__submenu').forEach((el) => {
    el.style.position = 'static';
    el.style.transform = 'none';
    el.style.zIndex = 'auto';
    el.style.opacity = '1';
    el.style.visibility = 'visible';
  });

  // Hide close buttons
  document.querySelectorAll('.mobile-facets__close-button').forEach((btn) => {
    btn.style.display = 'none';
  });
}

// Run on page load
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  keepFiltersOpen();
} else {
  document.addEventListener('DOMContentLoaded', keepFiltersOpen);
}

// Re-run when Shopify re-renders sections
document.addEventListener('shopify:section:load', keepFiltersOpen);
document.addEventListener('shopify:section:select', keepFiltersOpen);

// Optional: re-run when drawer reopens
document.addEventListener('click', function (e) {
  if (e.target.closest('.mobile-facets__open-wrapper')) {
    setTimeout(keepFiltersOpen, 100); // Give drawer time to open
  }
});


// Prevent <summary> clicks from toggling <details>
document.addEventListener('click', function (e) {
  const summary = e.target.closest('summary');
  if (summary && summary.closest('.mobile-facets__details')) {
    e.preventDefault();
  }
});

